module.exports = __webpack_public_path__ + "fonts/Typo_Round_Light_Demo.78eb705c.otf";